// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#viewport-tester {
  display: none;
  content: " ";
  width: 1px;
  height: 1px;
}

@media (min-width: 1281px) {
  #viewport-tester.desktop {
    display: block;
  }
}

@media (min-width: 1024px) {
  #viewport-tester.laptop {
    display: block;
  }
}

@media (min-width: 768px) {
  #viewport-tester.tablet {
    display: block;
  }
}

@media (min-width: 481px) {
  #viewport-tester.phablet {
    display: block;
  }
}

@media (min-width: 320px) {
  #viewport-tester.mobile {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/view-port.scss","webpack://./src/style/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AADF;;ACHI;EDOJ;IAEI,cAAA;EADF;AACF;;ACJI;EDQJ;IAEI,cAAA;EADF;AACF;;ACLI;EDSJ;IAEI,cAAA;EADF;AACF;;ACNI;EDUJ;IAEI,cAAA;EADF;AACF;;ACPI;EDWJ;IAEI,cAAA;EADF;AACF","sourcesContent":["@import \"mixins.scss\";\n\n#viewport-tester {\n  display: none;\n  content: ' ';\n  width: 1px;\n  height: 1px;\n}\n\n#viewport-tester.desktop {\n  @include breakpoint(desktop) {\n    display: block;\n  }\n}\n\n#viewport-tester.laptop {\n  @include breakpoint(laptop) {\n    display: block;\n  }\n}\n\n#viewport-tester.tablet {\n  @include breakpoint(tablet) {\n    display: block;\n  }\n}\n\n#viewport-tester.phablet {\n  @include breakpoint(phablet) {\n    display: block;\n  }\n}\n\n#viewport-tester.mobile {\n  @include breakpoint(mobile) {\n    display: block;\n  }\n}\n","﻿@mixin breakpoint($point) {\n  @if $point == desktop {\n    @media (min-width: 1281px) {\n      @content;\n    }\n  }\n  @else if $point == laptop {\n    @media (min-width: 1024px) {\n      @content;\n    }\n  }\n  @else if $point == tablet {\n    @media (min-width: 768px) {\n      @content;\n    }\n  }\n  @else if $point == phablet {\n    @media (min-width: 481px) {\n      @content;\n    }\n  }\n  @else if $point == mobile {\n    @media (min-width: 320px) {\n      @content;\n    }\n  }\n}\n\n@mixin transition($value) {\n  transition: $value;\n  -webkit-transition: $value;\n  -moz-transition: $value;\n  -ms-transition: $value;\n  -o-transition: $value;\n}\n\n@mixin transform($value) {\n  -webkit-transform: $value;\n  -ms-transform: $value;\n  transform: $value;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
